<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>
<div class="panel  "  *ngIf="!tablaEstandar" >

    <!--div class="encabezado col-sm-10"  *ngIf="!tablaEstandar && !marca ">     
<img src="./assets/images/Elementos/PLECA_EC.png"  (click)="sectorByIDM(1)" class="titleIma" />
    </div-->
    
    
    <div class="row">
        <div class="container">
   
    <div class=" col-sm-12 leyenda4 mi-cursor"  *ngIf="!tablaEstandar && !marca "  (click)="sectorByIDM(1)" >     
<p  mi-cursor>ESTÁNDARES DE MARCA (ECM)</p>
    </div>
</div>
</div>
</div>
   
    <div class="panel  "  *ngIf="marca"   >
        <!--div class="encabezado col-sm-10" >     
            <img src="./assets/images/Elementos/PLECA_EC.png"   class="titleIma" />
                </div-->
                <div class="row">
                    <div class="container">
                        <div class="col-sm-10">
                            <img src="./assets/images/Elementos/marca.png"  class="carrucel" />
            
                        </div>
                    </div>
            <br>
                </div>
                <div class=" col-sm-12 leyenda3 "  >     
                    <p>ESTÁNDARES DE MARCA (ECM)</p>
                        </div>
                <br><br>
                <br><br>
                <br><br>
                
                <div class="row">
                    <div class="container">
                           <div class="col-sm-12  leyenda2" >
                            <p>
                                Los Estándares de Competencia de Marca (ECM) son aquellos cuyos derechos de autor, propiedad industrial o
                                intelectual son conservados por la organización que los desarrolló.
                            </p>
                            <p>
                                Estos Estándares de Competencia son desarrollados por empresas u organizaciones que gozan de amplio prestigio
nacional e internacional. De ahí que el CONOCER incorpore certificaciones altamente valoradas en México y/o en el
mundo; generando certidumbre y contribuyendo a una mayor productividad y competitividad para las empresas; así
como a una mayor empleabilidad y movilidad laboral para las personas.

                            </p>
                           </div>
                    </div> 
                </div>
                <br>
    <div class="container">
        <div class="col-sm-1">
            <br>
            &nbsp; <span><img src="./assets/images/icon/lupa.png" class="iconLupa"></span>
        </div>
        <div class="col-sm-11">
            <mat-form-field appearance="standard">
                <mat-label>Buscar</mat-label>
                <input matInput (keyup)="applyFilter2($event)" placeholder="Buscar" #input>
            </mat-form-field>
        </div>
    </div>

<div class="row" >
    <div  class="container">
        <div  class="col-sm-12 example-container" >
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource2" matSort class="table table-striped table-bordered" >
                    
                    <tr mat-header-row *matHeaderRowDef="displayedCol"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedCol;"></tr>

                    <ng-container matColumnDef="codigo">
                        <th mat-header-cell *matHeaderCellDef  mat-sort-header class="letraD marcaAgua">Código</th>
                        <td mat-cell *matCellDef="let element"   (click)="sectorByID(element)" class="letraE">{{element.codigo}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="nivel">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="letraD marcaAgua" >Nivel</th>
                        <td  mat-cell *matCellDef="let element" (click)="sectorByID(element)"  class="letraE">{{element.nivel}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="titulo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="letraD marcaAgua">Título</th>
                        <td mat-cell *matCellDef="let element" (click)="sectorByID(element)"  class="letraE">{{element.titulo}} </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="comite">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="letraD marcaAgua"  >Comité</th>
                        <td mat-cell *matCellDef="let element" (click)="sectorByID(element)"  class="letraE">{{element.comite}} </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="secProductivo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="letraD marcaAgua">Sector Productivo</th>
                        <td mat-cell *matCellDef="let element" (click)="sectorByID(element)"  class="letraE">{{element.secProductivo}} </td>
                    </ng-container>
          
                </table>
                <mat-paginator
                         showFirstLastButtons 
                         aria-label="Select page of periodic elements">
                </mat-paginator>
                <br>
                
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="row">
    <div class="container">
<div class="col-sm-5" ></div>
<div style="text-align: center;" class="col-sm-1" >
<button mat-button (click) = "back()"><img src="./assets/images/icon/Atras.png"  class=" imagen" /></button>
</div>
<div style="text-align: center;"  class="col-sm-1">
<button mat-button (click) = "home()"><img src="./assets/images/icon/Home.png"  class=" imagen" /></button>
</div>
</div>
</div>
</div>
